/**
 * MB-bundle-block.js
 * Handles the "Add Bundle To Cart" button (adds every core bundle product in
 * one request) and the individual "+" quick-add buttons in the add-ons row.
 * Both paths use the standard Shopify /cart/add.js AJAX endpoint so this
 * works regardless of which cart drawer/notification system the theme uses.
 *
 * After a successful add, dispatches a `cart:updated` CustomEvent on
 * document with `{ detail: { itemCount } }` — the header built alongside
 * this section already listens for that event to refresh its cart badge.
 * If this theme's own cart drawer listens for a different event, wire an
 * additional dispatch here once you know its name.
 */
(function () {
  function parseVariantIds(raw) {
    return (raw || '')
      .split(',')
      .map(function (id) { return id.trim(); })
      .filter(Boolean)
      .map(function (id) { return parseInt(id, 10); })
      .filter(function (id) { return !isNaN(id); });
  }

  function setStatus(el, message, isError) {
    if (!el) return;
    el.textContent = message;
    el.classList.toggle('MB-bundle__add-status--error', !!isError);
  }

  function refreshCartCount() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { itemCount: cart.item_count }
        }));
        return cart;
      })
      .catch(function () { /* non-fatal: header badge just won't refresh */ });
  }

  // Opens the theme's cart drawer instead of navigating to /cart.
  // Falls back to the old redirect if the drawer isn't on the page.
  function goToCartOrOpenDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: { open: true }
    }));
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (data) {
          throw new Error(data.description || 'Toevoegen aan je winkelwagen lukte niet.');
        });
      }
      return res.json();
    });
  }

  function initBundleAddButton(bundleEl) {
    var button = bundleEl.querySelector('[data-mb-bundle-add]');
    var status = bundleEl.querySelector('[data-mb-bundle-status]');
    if (!button) return;

    var originalLabel = button.textContent.trim();
    var variantIds = parseVariantIds(button.getAttribute('data-variant-ids'));

    button.addEventListener('click', function () {
      if (variantIds.length === 0) {
        setStatus(status, 'Er zitten nog geen producten in dit pakket.', true);
        return;
      }

      button.disabled = true;
      button.textContent = 'Toevoegen...';
      setStatus(status, '');

      var items = variantIds.map(function (id) { return { id: id, quantity: 1 }; });

    
        addItems(items)
        .then(function () { return refreshCartCount(); })
        .then(function () {
            goToCartOrOpenDrawer();
            button.textContent = originalLabel;
          button.disabled = false;
        })
        .catch(function (err) {
          button.textContent = originalLabel;
          button.disabled = false;
          setStatus(status, err.message || 'Het pakket toevoegen lukte niet, probeer het opnieuw.', true);
        })
        .finally(function () {
          button.textContent = originalLabel;
          button.disabled = false;
        });
    });
  }

  function initAddonButtons(bundleEl) {
    var buttons = bundleEl.querySelectorAll('[data-mb-addon-add]');
    buttons.forEach(function (button) {
      var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
      if (isNaN(variantId)) return;

      button.addEventListener('click', function () {
        button.disabled = true;
        var originalContent = button.textContent;
        button.textContent = '...';

        addItems([{ id: variantId, quantity: 1 }])
            .then(function () { return refreshCartCount(); })
               .then(function () {
            goToCartOrOpenDrawer();
          })
          .catch(function () { /* non-fatal */ })
          .finally(function () {
            button.textContent = originalContent;
            button.disabled = false;
          });
      });
    });
  }
    function initAddonPagination(bundleEl) {
    var row = bundleEl.querySelector('[data-mb-addons-row]');
    var dotsWrap = bundleEl.querySelector('[data-mb-addons-dots]');
    if (!row || !dotsWrap) return;

    var mq = window.matchMedia('(max-width: 767.98px)');
    var ticking = false;

    function buildDots() {
      dotsWrap.innerHTML = '';
      var items = row.querySelectorAll('.MB-bundle__addon-item');
      var perPage = 2;
      var pageCount = Math.ceil(items.length / perPage);

      if (!mq.matches || pageCount <= 1) return;

      for (var i = 0; i < pageCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'MB-bundle__addons-dot' + (i === 0 ? ' MB-bundle__addons-dot--active' : '');
        dot.setAttribute('aria-label', 'Ga naar dia ' + (i + 1));
        (function (pageIndex) {
          dot.addEventListener('click', function () {
            row.scrollTo({ left: pageIndex * row.clientWidth, behavior: 'smooth' });
          });
        })(i);
        dotsWrap.appendChild(dot);
      }
    }

    function updateActiveDot() {
      var dots = dotsWrap.querySelectorAll('.MB-bundle__addons-dot');
      if (!dots.length || row.clientWidth === 0) return;
      var activeIndex = Math.round(row.scrollLeft / row.clientWidth);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('MB-bundle__addons-dot--active', i === activeIndex);
      });
    }

    row.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateActiveDot();
        ticking = false;
      });
    });

    buildDots();
    if (mq.addEventListener) {
      mq.addEventListener('change', buildDots);
    } else {
      mq.addListener(buildDots); // Safari <14 fallback
    }
    window.addEventListener('resize', function () {
      buildDots();
      updateActiveDot();
    });
  }

   function initDragScroll(row) {
    if (!row || row.dataset.mbDragInit) return;
    row.dataset.mbDragInit = 'true';

    var ITEM_SELECTOR = '.MB-bundle__addon-item, .MB-bundle__item';
    var THRESHOLD = 5;        // px before a press becomes a drag
    var MOMENTUM = 180;       // how far a flick carries (ms of velocity)

    var isDown = false;
    var moved = false;
    var pointerId = null;
    var startX = 0;
    var startScroll = 0;
    var targetScroll = 0;
    var rafId = null;
    var samples = [];         // [{x, t}] for release velocity
    var settleTimer = null;

    function render() {
      row.scrollLeft = targetScroll;
      rafId = null;
    }

    function maxScroll() {
      return row.scrollWidth - row.clientWidth;
    }

    function nearestItemLeft(projected) {
      var rowLeft = row.getBoundingClientRect().left;
      var best = projected;
      var bestDist = Infinity;
      row.querySelectorAll(ITEM_SELECTOR).forEach(function (item) {
        var left = item.getBoundingClientRect().left - rowLeft + row.scrollLeft;
        var dist = Math.abs(left - projected);
        if (dist < bestDist) { bestDist = dist; best = left; }
      });
      return Math.max(0, Math.min(best, maxScroll()));
    }

    function finishSettle() {
      clearTimeout(settleTimer);
      row.removeEventListener('scrollend', finishSettle);
      row.classList.remove('is-dragging');
    }

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      if (pointerId !== null && row.hasPointerCapture && row.hasPointerCapture(pointerId)) {
        row.releasePointerCapture(pointerId);
      }
      pointerId = null;
      if (!moved) return;

      if (rafId) { cancelAnimationFrame(rafId); render(); }

      // Release velocity from the last ~100ms of movement
      var velocity = 0;
      var now = performance.now();
      var recent = samples.filter(function (s) { return now - s.t < 100; });
      if (recent.length > 1) {
        var first = recent[0];
        var last = recent[recent.length - 1];
        var dt = last.t - first.t || 1;
        velocity = (last.x - first.x) / dt; // px per ms
      }

      var projected = row.scrollLeft - velocity * MOMENTUM;
      var target = nearestItemLeft(projected);

      // Glide smoothly to the nearest card, then hand snapping back to CSS
      row.addEventListener('scrollend', finishSettle);
      settleTimer = setTimeout(finishSettle, 700); // fallback for browsers without scrollend
      row.scrollTo({ left: target, behavior: 'smooth' });
    }

    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return; // touch = native swipe
      if (row.scrollWidth <= row.clientWidth) return;
      finishSettle();
      isDown = true;
      moved = false;
      pointerId = e.pointerId;
      startX = e.clientX;
      startScroll = row.scrollLeft;
      targetScroll = startScroll;
      samples = [{ x: e.clientX, t: performance.now() }];
    });

    row.addEventListener('pointermove', function (e) {
      if (!isDown || e.pointerId !== pointerId) return;
      if (e.buttons !== 1) { endDrag(); return; }
      var dx = e.clientX - startX;
      if (!moved) {
        if (Math.abs(dx) < THRESHOLD) return;
        moved = true;
        row.setPointerCapture(pointerId);
        row.classList.add('is-dragging');
      }
      e.preventDefault();
      samples.push({ x: e.clientX, t: performance.now() });
      if (samples.length > 10) samples.shift();

      targetScroll = Math.max(0, Math.min(startScroll - dx, maxScroll()));
      if (!rafId) rafId = requestAnimationFrame(render); // max one scroll write per frame
    });

    row.addEventListener('pointerup', endDrag);
    row.addEventListener('pointercancel', endDrag);

    row.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);

    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-mb-bundle]').forEach(function (bundleEl) {
      if (bundleEl.dataset.mbBundleInitialized) return;
      bundleEl.dataset.mbBundleInitialized = 'true';
      initBundleAddButton(bundleEl);
      initAddonButtons(bundleEl);
           initAddonPagination(bundleEl);
      initDragScroll(bundleEl.querySelector('[data-mb-addons-row]'));
      initDragScroll(bundleEl.querySelector('.MB-bundle__items'));
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();